import { html, ViewTemplate, repeat } from '@microsoft/fast-element';
import type { MultiSegmentedControl } from './multi-segmented-control';

export const MultiSegmentedControlTemplate: ViewTemplate<MultiSegmentedControl> = html`
  <div
    class="segmented-options ${(x) =>
      x.hideControl === 'true' ? 'segmented-options-hide-control' : ''}"
  >
    ${repeat(
      (x) => x.options,
      html`
        <zero-checkbox
          @change="${(x, c) => c.parent.onChange(x, c.event)}"
          ?checked=${(x, c) => c.parent.selectedOptions.find((elm) => elm === x)}
          class=${(x, c) => (c.parent.hideControl === 'true' ? 'hide-control' : '')}
        >
          ${(x) => x}
        </zero-checkbox>
      `
    )}
  </div>
`;
